import type { Broadcast, ChannelAction, ChannelListener } from '../types';

/**
 * Create a broadcast channel.
 * TODO: implementing unsubscribe
 *
 * @param  {string}    name Broadcast channel name
 * @return {Broadcast}
 */
function createBroadcastChannel(name: string): Broadcast {
  const channel = new BroadcastChannel(name);

  const subscriptions = new Map<string, Array<ChannelListener>>();

  function channelListener(event: MessageEvent<ChannelAction>) {
    const { type, payload } = event.data;

    const listeners = subscriptions.get(type) || [];

    for (const listener of listeners) {
      listener({ type, payload });
    }
  }

  channel.addEventListener('message', channelListener);
  channel.addEventListener('messageerror', console.error);

  const api = {
    subscribe(type: string, listener: (action: ChannelAction) => void) {
      const cached: Array<ChannelListener> = subscriptions.has(type)
        ? (subscriptions.get(type) as [ChannelListener])
        : [];

      subscriptions.set(type, cached.concat(listener));
    },
    unsubscribe() {
      //TODO
    },
    send(action: ChannelAction) {
      channel.postMessage(action);
    },
    reset() {
      subscriptions.clear();
    },
    close() {
      channel.close();
      channel.removeEventListener('message', channelListener);
    },
  };

  return api;
}

export { createBroadcastChannel };
